import { render, staticRenderFns } from "./SgrpChart.vue?vue&type=template&id=6aeb68fc"
import script from "./SgrpChart.vue?vue&type=script&lang=js"
export * from "./SgrpChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports